import React, { FC } from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { HomesteadLogo } from '@/atoms/Logos/HomesteadLogo'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { AvailableTabsPresales } from '@/views/PreSales/PreSalesGiveawayView/PreSalesGiveawayView'
import { HomesteadFooterMD, HomesteadTitleXS } from '@/views/PreSales/PreSalesGiveawayView/components/Typography'

interface GiveawayFooterProps {
  scrollToTab: (tab: AvailableTabsPresales) => void
  scrollToProducts: () => void
}
export const GiveawayFooter: FC<GiveawayFooterProps> = ({ scrollToTab, scrollToProducts }) => {
  const { t } = useTranslate('tickets')

  return (
    <footer className="bg-homestead-blue">
      <div className="mx-auto flex flex-col  gap-10 px-4 py-[72px] lg:max-w-[1440px] lg:flex-row lg:gap-x-[120px]">
        <div className="lg:w-[160px]">
          <HomesteadLogo width={160} />
        </div>
        <div className="flex flex-col gap-10 bg-homestead-blue lg:flex-row-reverse">
          <div>
            <HomesteadTitleXS color="white" className="mb-2 !font-semibold">
              {t('giveawayRules', 'Giveaway Rules')}
            </HomesteadTitleXS>
            <HomesteadFooterMD color="white">
              <Translate t={t} i18nKey="homesteadSweepstakesGeneralRulesV2">
                * * * LIMIT OF FOURTEEN THOUSAND ONE HUNDRED (14,100) ENTRIES PER PERSON/EMAIL ADDRESS. * * * NO
                PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO ENTER OR WIN. PURCHASE OR PAYMENT DOES NOT IMPROVE YOUR
                CHANCE OF WINNING. The 300K Instant Homestead Giveaway is open only to legal residents of the 48
                Contiguous U.S. States (VOID in AK and HI) & DC, 21 or older. Void elsewhere and where prohibited..
                Promotion starts 10/11/24 and ends 12/22/24. To enter, visit https://angel.com/homesteadgiveaway .
                Sponsor: Angel Studios, 295 W Center Street, Provo, UT 84601.. Subject to complete Official Rules at{' '}
                <a href="https://bit.ly/HomesteadSweeps" target="_blank" className="underline">
                  https://bit.ly/HomesteadSweeps.
                </a>
              </Translate>
            </HomesteadFooterMD>
          </div>
          <FlexColumn className="lg:min-w-64">
            <HomesteadTitleXS color="white" className="mb-2 !font-semibold">
              {t('siteNavigation', 'Site Navigation')}
            </HomesteadTitleXS>
            <HomesteadFooterMD color="white" onClick={scrollToProducts} className="cursor-pointer underline">
              {t('preOrderTicketsFooterlink', 'Pre-Order Tickets')}
            </HomesteadFooterMD>
            <HomesteadFooterMD
              color="white"
              onClick={() => scrollToTab('details')}
              className="cursor-pointer underline"
            >
              {t('giveawayDetails', 'Giveaway Details')}
            </HomesteadFooterMD>
            <HomesteadFooterMD
              color="white"
              onClick={() => scrollToTab('prizeItems')}
              className="cursor-pointer underline"
            >
              {t('prizeItems', 'Prize Items')}
            </HomesteadFooterMD>
            <HomesteadFooterMD
              color="white"
              onClick={() => scrollToTab('updates')}
              className="cursor-pointer underline"
            >
              {t('updates', 'Updates')}
            </HomesteadFooterMD>
            <HomesteadFooterMD color="white" onClick={() => scrollToTab('faq')} className="cursor-pointer underline">
              {t('faqs', 'FAQs')}
            </HomesteadFooterMD>
            <div className="mt-10 hidden md:block">
              <HomesteadFooterMD className="!text-[#AAAFB4]">
                <Translate t={t} i18nKey="footerCopyright">
                  © 2024 Angel Studios, LLC. All rights reserved.
                </Translate>
              </HomesteadFooterMD>
            </div>
          </FlexColumn>

          <div className="md:hidden">
            <HomesteadFooterMD className="!text-[#AAAFB4]">
              <Translate t={t} i18nKey="footerCopyright">
                © 2024 Angel Studios, LLC. All rights reserved.
              </Translate>
            </HomesteadFooterMD>
          </div>
        </div>
      </div>
    </footer>
  )
}
